import cookie from 'react-cookies'
import Constants from 'scripts/base/Constants'

class ConsentCookie {
  SetDefault = () => {
    return Constants.CookieConsentDefault
  }

  SetAllowAll = () => {
    return this.SetDefault()
  }

  GetData = () => {
    return cookie.load(Constants.CookieConsentName)
  }

  hasConsent = (setting) => {
    const consent = this.GetData() || this.SetDefault()
    return consent[setting]
  }

  Clear = () => {
    cookie.remove(Constants.CookieConsentName, { path: '/' })
  }

  Save = (setting) => {
    let expires = new Date()
    expires.setDate(expires.getDate() + 365)
    cookie.save(
      Constants.CookieConsentName,
      setting,
      {
        secure: false,
        httpOnly: false,
        path: '/',
        expires: expires
      }
    )
  }
}

export default ConsentCookie



// WEBPACK FOOTER //
// ./assets/js/lib/ConsentCookie.js